import { AsyncPipe, DatePipe, SlicePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { AuthorizeDirective } from '@directives';
import { environment } from '@environment';
import { Attachment } from '@models';
import { HumanReadableSizePipe, ResolveUserPipe } from '@pipes';

@Component({
  selector: 'app-attachment-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  imports: [
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatDialogModule,
    AuthorizeDirective,
    ResolveUserPipe,
    HumanReadableSizePipe,
    AsyncPipe,
    DatePipe,
    SlicePipe,
    RouterLink,
  ],
})
export class AttachmentItemComponent {
  dialogRef = inject<MatDialogRef<AttachmentItemComponent>>(MatDialogRef);
  data = inject<{
    attachment: Attachment;
    isReleased: boolean;
    canDownload: boolean;
    requiresAuthorization: boolean;
  }>(MAT_DIALOG_DATA);

  public fileHostUrl: string;
  public attachment: Attachment;
  public requiresAuthorization: boolean;
  public canDownload: boolean;
  public isReleased: boolean;

  constructor() {
    const data = this.data;

    this.fileHostUrl = environment.kinkoHost;

    this.attachment = data.attachment;
    this.requiresAuthorization = data.requiresAuthorization;
    this.canDownload = data.canDownload;
    this.isReleased = data.isReleased;
  }

  public get recordRef(): string | undefined {
    if (!this.attachment?.recordId) {
      return undefined
    }

    switch (this.attachment?.datasetId) {
      case environment.mapArchiveDatasetId:
        return `/map/archive/${this.attachment?.recordId}`;
      case environment.geologicalSampleDatasetId:
        return `/geology/sample/${this.attachment?.recordId}`;
      case environment.vesselDatasetId:
        return `/vessel/${this.attachment?.recordId}`;
      default:
        return undefined;
    }
  }
}
